import { aboutData } from '@/mocks/about';

export default function Reputation() {
  const { reputation } = aboutData;

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`text-sm ${i < rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
      ></i>
    ));
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            {reputation.title}
          </h2>
          <p className="text-foreground-500 text-sm">{reputation.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reputation.reviews.map((review) => (
            <div
              key={review.name}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <p className="font-medium text-foreground-900 text-sm">{review.name}</p>
                  <p className="text-foreground-400 text-xs">{review.date}</p>
                </div>
              </div>
              <div className="flex items-center gap-1 mb-3">
                {renderStars(review.rating)}
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                &ldquo;{review.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}